<template>
    <footer class="footer has-cards">
  
        <div class="container">
            
            <div class="row row-grid align-items-center my-md">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2">Thank you for using FollowMeTraveller!</h3>
                    <h4 class="mb-0 font-weight-light">You can follow us on any of these platforms.</h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper">
                    <a target="_blank" rel="noopener" href="https://twitter.com/Followmetravel2"
                       class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-twitter"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://www.facebook.com/deebee8488"
                       class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Like us">
                        <i class="fa fa-facebook-square"></i>
                    </a>
                     <a target="_blank" rel="noopener" href="https://www.youtube.com/channel/UCnp4dgbR4fL7rDqqnQYsHww"
                       class="btn btn-neutral btn-icon-only btn-youtube btn-lg btn-round" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-youtube"></i>
                    </a>
                     <a target="_blank" rel="noopener" href="https://www.instagram.com/follow_me_traveller/"
                       class="btn btn-neutral btn-icon-only btn-instagram btn-lg btn-round" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-instagram"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://in.pinterest.com/followmetraveller/"
                       class="btn btn-neutral btn-icon-only btn-pinterest btn-lg btn-round" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-pinterest"></i>
                    </a>
                    
                </div>
            </div>
            
            <div class="row row-grid align-items-center my-md">
                <div class="col-lg-4 col-sm-12">
                    <ul class="footerlinks">
                        <li><router-link to="/terms" class="dropdown-item cl-primary">Terms & Conditions</router-link></li>
                        <li><router-link to="/privacy" class="dropdown-item cl-primary">Privacy Policy</router-link></li>
                    </ul>
                </div>
                <div class="col-lg-4 col-sm-12 mobile">
                    <ul class="footerlinks">
                        <li><router-link to="/aboutus" class="dropdown-item cl-primary">About Us</router-link></li>
                        <li><router-link to="/contactus" class="dropdown-item cl-primary">Contact Us</router-link></li>
                    </ul>
                </div>
            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        &copy; {{year}}
                        <a href="#" target="_blank" rel="noopener">Deepak Travels</a>
                    </div>
                </div>
                <!-- <div class="col-md-6">
                    <ul class="nav nav-footer justify-content-end">
                        
                        <li class="nav-item">
                            <a href="#" class="nav-link" target="_blank" rel="noopener">About
                                Us</a>
                        </li>
                        <li class="nav-item">
                            <a href="#" class="nav-link" target="_blank" rel="noopener">Blog</a>
                        </li>
                        
                    </ul>
                </div> -->
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
@media (max-width: 769px) {

.mobile{
    margin-top: -3.9%!important;
}
}
</style>
